"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaItem = props => {
  const {
    sectionType,
    mediaItemData
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/".concat(sectionType, "/").concat(mediaItemData.id)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-item"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: mediaItemData.feature_img,
    className: "media-image"
  }), (mediaItemData === null || mediaItemData === void 0 ? void 0 : mediaItemData.date) && /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__Xtra-larger-regular"
  }, mediaItemData.date), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__Xtra-larger-SemiBold con-text__Xtra-larger-SemiBold--bold con-text__Xtra-larger-SemiBold--dark-green"
  }, mediaItemData.title)));
};
exports.MediaItem = MediaItem;
MediaItem.propTypes = {
  sectionType: _propTypes.default.string,
  mediaItemData: _propTypes.default.object
};